import LazyImage from '@atoms/LazyImage';
import { Text } from '@ui/atoms';
import React from 'react';

export const InvoiceInvestmentRiskFactors = ({ invoiceRiskFactors }) => {
    const { investmentRisks, riskMitigation, note } = invoiceRiskFactors;
    const { risks, title: investmentTitle } = investmentRisks;
    const { mitigation, title: riskTitle } = riskMitigation;
    return (
        <div className="w-full bg-id-risk-gradient">
            <div className="flex flex-col w-full max-w-[1136px] xl:mx-auto xl:px-0 gap-10 px-4 py-6 xl:flex-row md:gap-8 xl:gap-12 md:py-10 md:px-6 xl:py-10">
                <InvoiceRiskFactorCardContainer
                    keyPoints={risks}
                    title={investmentTitle}
                    borderColor="border-primary-100"
                />
                <InvoiceRiskFactorCardContainer
                    keyPoints={mitigation}
                    title={riskTitle}
                    borderColor="border-secondary-200"
                    note={note}
                />
            </div>
        </div>
    );
};

const InvoiceRiskFactorCardContainer = ({
    title,
    keyPoints,
    borderColor,
    note,
}) => {
    return (
        <div className="flex flex-col items-start gap-6 xl:flex-1">
            <Text
                content={title}
                className={`pb-2 h5-regular text-gray-800 border-b ${borderColor}`}
                htmlTag='h2'
            />
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-6">
                    {keyPoints.map((item, index) => {
                        const { title, icon } = item;
                        return (
                            <InvoiceRiskFactorCard
                                key={index}
                                title={title}
                                icon={icon}
                            />
                        );
                    })}
                </div>
                {note && (
                    <Text content={note} className="text-gray-500 p7-regular" />
                )}
            </div>
        </div>
    );
};

const InvoiceRiskFactorCard = ({ title, icon }) => {
    return (
        <div className="flex items-center gap-3">
            <LazyImage src={icon} className="w-8 aspect-square md:w-12 relative" />
            <Text
                content={title}
                className="text-gray-800 p6-medium md:p5-medium"
            />
        </div>
    );
};
